import { useMemo } from 'react';
import { CSSTransition, SwitchTransition } from 'react-transition-group';
import filterIcon from '~/assets/icons/filter.svg';
import { photoModeFilters } from '~/shared';

import { useLayoutSelector } from '../../redux/hooks';
import { TextLabel } from '../TextLabel';
import { StyledContainer, StyledFilterNameContainer } from './Filters.styled';

const Filters: React.FC = () => {
	const filterActive = useLayoutSelector(
		(state) => state.photoMode.filterActive,
	);

	const filterVisible = useMemo(
		() => filterActive !== photoModeFilters[0],
		[filterActive],
	);

	const filterNumber = useMemo(
		() => photoModeFilters.indexOf(filterActive),
		[filterActive],
	);

	return (
		<CSSTransition
			in={filterVisible}
			classNames={'filter'}
			timeout={{
				appear: 600,
				enter: 600,
				exit: 5300,
			}}
		>
			<StyledContainer>
				<TextLabel
					style={{ fontSize: '16px', color: '#FFFFFF', textAlign: 'center' }}
				>
					<span style={{ fontWeight: 400, opacity: 0.5 }}>Фильтр</span>
					<br />
					<SwitchTransition>
						<CSSTransition
							key={filterActive.name}
							timeout={500}
							classNames={'filter-name'}
							addEndListener={(node, done) =>
								node.addEventListener('transitionend', done, false)
							}
						>
							<StyledFilterNameContainer>
								<span style={{ fontWeight: 700 }}>{filterActive.name}</span>{' '}
								<span style={{ opacity: 0.5 }}>
									{filterNumber !== 0 &&
										`(${filterNumber} / ${photoModeFilters.length - 1})`}
								</span>
							</StyledFilterNameContainer>
						</CSSTransition>
					</SwitchTransition>
				</TextLabel>
				<img src={filterIcon} />
			</StyledContainer>
		</CSSTransition>
	);
};

export { Filters };
